<template>
  <main style="border: 3px solid red">
    <slot />
  </main>
</template>
